interface ICompanyStatRowProps {
  row: ICompanyStat;
}
function CompanyStatsRow({ row }: ICompanyStatRowProps) {
  return (
    <tr>
      <td>{row.name ?? 0}</td>
      <td>{row.connections ?? 0}</td>
      <td>{row.adStudies ?? 0}</td>
      <td>{row.procedureEvents ?? 0}</td>
      <td>{row.activeResearches ?? 0}</td>
      <td>{row.comparativeStudies ?? 0}</td>
    </tr>
  );
}

export default CompanyStatsRow;
